import { stripAllNonNumericChars } from '@mentimeter/ragnar-utils';
import { DSC } from './DSC';

export const breakpoints = DSC.breakpoints.map<number>(stripAllNonNumericChars);
